import TopTabs from './TopTabsClient';
import { Screen } from '../views/Screen';

TopTabs.Screen = Screen;

export { TopTabs };

export * from '../react-navigation/material-top-tabs';

export default TopTabs;
